/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DynamodbTableRestoreDestination } from '../models/DynamodbTableRestoreDestination';
import { RestoreMethod } from '../models/RestoreMethod';

export class DynamoDBRestoreMethodAvailabilityRequest {
  'restoreMethod': RestoreMethod;
  'destination'?: DynamodbTableRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreMethod",
      "baseName": "restoreMethod",
      "type": "RestoreMethod",
      "format": ""
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "DynamodbTableRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DynamoDBRestoreMethodAvailabilityRequest.attributeTypeMap;
  }

  public constructor() {
  }
}



